<script>
	import { onMount } from 'svelte';

	// Build Chat Manager
	window.app.chat_manager = new window.ChatManager();
	window.app.chat_manager.ai_messages = window.ai_messages;
	window.app.chat_manager.disable_chat_input();
	window.app.chat_manager.hide_chat_input();

	let container_el;

	onMount(() => {
        // replace to maintain the integrity with the existing layout
		window.app.chat_manager.replace_container(container_el);
	});

</script>

<aside id="chat-container" class="chat-container hidden" bind:this={container_el}>
</aside>